import { Modal } from 'antd';
import moment from 'moment';
import { countries } from 'countries-list';

import fr from '../intl/fr.json';

export const app = {
    dbpref: 'fyv_',
    version: '2.2.7',
}

export const dates = {
    yr: moment().format('YYYY'),
}

export const loading = (content) => {
    return new Promise((resolve) => {
        content = <div dangerouslySetInnerHTML={{ __html: `<i class="fa fa-spin fa-spinner"></i> <span>${content}</span>` }} />
        const loading = Modal.info({
            icon: null,
            title: null,
            centered: true,
            content,
            width: '250px',
            className: 'fyv-loading',
            cancelText: <div />,
        });
        resolve(loading);
    });
}

export const alert = (modal, title, content, props) => {
    Modal[modal || 'info']({
        // icon: null,
        title,
        centered: true,
        content,
        okText: 'Okay!',
        width: '300px',
        cancelTextProps: { style: { display: 'none' } },
        ...props,
    });
}


// ::: storage
export const setCookie = (key, value, expires = 7) => {
    try {
        var d = new Date();
        d.setTime(d.getTime() + expires * 24 * 60 * 60 * 1000);
        var expires = 'expires=' + d.toUTCString();
        return document.cookie = `${app.dbpref + key}=${value};${expires};path=/;`;
    } catch (e) {
        console.log(e);
        return;
    }
};

export const getCookie = (key) => {
    try {
        var name = app.dbpref + key + '=';
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                if (c.split('=')[1].length !== 0) {
                    return c.substring(name.length, c.length);
                }
            }
        }
    } catch {
        return '';
    }
};

export const setCookieJson = (key, value, expires = 7) => {
    // console.log(key, value)
    setCookie(key, JSON.stringify(value), expires);
};

export const getCookieJson = (key) => {
    const value = getCookie(key);
    return value && JSON.parse(value) || {};
};

export const delCookie = (key) => {
    try {
        var expires = 'expires=-1';
        document.cookie = `${app.dbpref + key}=;${expires};path=/;`;
    } catch {
        return;
    }
};

export const setStorage = (key, value) => {
    try {
        if (key && value) {
            return localStorage.setItem(app.dbpref + key, value);
        }
    } catch {
        return;
    }
}

export const getStorage = (key) => {
    try {
        const value = localStorage.getItem(app.dbpref + key);
        return value || '';
    } catch {
        return '';
    }
}

export const setStorageJson = (key, value) => {
    return setStorage(key, JSON.stringify(value));
}

export const getStorageJson = (key) => {
    const value = getStorage(key);
    return value && JSON.parse(value) || '';
}

export const delStorage = (key) => {
    try {
        return localStorage.removeItem(app.dbpref + key);
    } catch {
        return;
    }
}

// ::: spinners
export const fspinner = <div style={{ textAlign: 'center', color: '#999', lineHeight: 320 + 'px', width: 100 + '%' }}><i className="fa fa-spin fa-circle-o-notch fa-5x"></i></div>;
export const fspinner_sm = <div style={{ textAlign: 'center', color: '#999', lineHeight: 120 + 'px', width: 100 + '%' }}><i className="fa fa-spin fa-circle-o-notch fa-3x"></i></div>;
export const fspinner_xs = <i className="fa fa-spin fa-circle-o-notch"></i>;

export const redirect = (to) => {
    window.location = to;
}

export const serverRedirect = (ctx, to) => {
    if (ctx && ctx.res && ctx.res.writeHead && to) {
        ctx.res.writeHead(302, {
            location: to,
        });
        ctx.res.end();
    }
}

export const generateOptions = (length, step = 1) => {
    const arr = [];
    for (let value = 0; value < length; value += step) {
        arr.push(value);
    }
    return arr;
}

export const shuffle = (array) => {
    array.sort(() => Math.random() - 0.5);
}

export const numberFormat = (number, decimal = 0) => {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: decimal === 0 ? 0 : 2, maximumFractionDigits: decimal }).format(number);
}

export const checkDates = (start, end) => {
    if (start && end) {
        return moment().isBetween(start, end);
    }
    return false;
}


export const isForeign = (country, source = {}) => {
    const sett = getStorageJson('settings') || {};
    const settCountries = getStorageJson('countries') || [];
    const myIP = countries[country.toUpperCase()] || {};
    let forex = (sett.forex || []).find(fx => fx.source === (source.currency || 'GHS') && fx.destination === myIP.currency) || { rate: 1 };
    let isForeign = settCountries.find(sc => sc.code.toLowerCase() === country.toLowerCase()) || {};
    let currency = forex.destination || (source.currency || 'GHS');
    forex['rate'] = +forex.rate;
    return {
        forex,
        currency,
        isForeign: isForeign.code ? false : true,
        decimal: typeof isForeign.decimal !== 'undefined' ? isForeign.decimal : source.decimal,
        country: country.toLowerCase(),
        myIP,
    };
}

export const chunk = (inputArray, chunkSize) => {
    return inputArray.reduce((resultArray, item, index) => {
        const chunkIndex = Math.floor(index / chunkSize);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [];
        }
        resultArray[chunkIndex].push(item);
        return resultArray
    }, []);
}

export const intl = (id, defaultM, values = {}) => {
    const lang = (getStorageJson('lang') || 'en').toLowerCase();
    const messages = { fr, en: {} };

    let di = id.split('.');
    let txt = messages[lang][di[0]] || {};
    const vals = (t) => {
        let o = Object.keys(values);
        for (var x = 0; x < o.length; x++) {
            t = t.replace(`{${o[x]}}`, values[o[x]]);
        }
        return t;
    }
    if (typeof txt === 'string') {
        return txt;
    } else {
        txt = (messages[lang][di[0]] || {})[di[1]];
        if (typeof txt === 'string') {
            return vals(txt);
        } else {
            txt = ((messages[lang][di[0]] || {})[di[1]] || {})[di[2]];
            if (typeof txt === 'string') {
                return vals(txt);
            } else {
                return vals(lang === 'en' ? defaultM : id);
            }
        }
    }
}

export const payWith = (pw) => {
    const sett = getStorageJson('settings') || {};
    if (pw.includes(':')) {
        return pw;
    } else {
        const pm = {
            'gh_momo': sett.gh.pay_with_momo,
            'gh_card': sett.gh.pay_with_card,
            'gh_foreign': sett.gh.pay_with_inter,
            'gh_crypto': sett.gh.pay_with_crypto,

            'ng_bank': sett.ng.pay_with_bank,
            'ng_card': sett.ng.pay_with_card,
            'ng_foreign': sett.ng.pay_with_inter,

            'ci_momo': sett.ci.pay_with_momo,
            'ci_card': sett.ci.pay_with_card,
            'ci_foreign': sett.ci.pay_with_inter,
        };
        const i = Math.floor(Math.random() * pm[pw].length);
        pw = pm[pw][i];
        return pw || '';
    }
}

export const sortString = (a, b, key) => {
    const fa = typeof a[key] === 'number' ? a[key] : a[key].toLowerCase();
    const fb = typeof b[key] === 'number' ? b[key] : b[key].toLowerCase();

    if (fa < fb) {
        return -1;
    }
    if (fa > fb) {
        return 1;
    }
    return 0;
}

export const encode = (str) => {
    var encoded = '';
    str = JSON.stringify(str);
    str = Buffer.from(str).toString('base64');
    str = Buffer.from(str).toString('base64');
    for (let i = 0; i < str.length; i++) {
        var a = str.charCodeAt(i);
        var b = a ^ 10;
        encoded = encoded + String.fromCharCode(b);
    }
    encoded = Buffer.from(encoded).toString('base64');
    return encoded;
}

export const fingerprint = () => {
    const random = () => Math.random().toString(36).substring(2, 15);
    let id = getCookie('fingerprint');
    if (!id) {
        id = random() + random();
        setCookie('fingerprint', id, 180);
    }
    return id;
}